import { createRouter, createWebHistory } from 'vue-router';
import HomeView from '../views/HomeView.vue';
import ManagerForm from '@/views/managers/ManagerForm.vue';
import Login from '@/views/users/Login.vue';
import ManagerView from '@/views/managers/ManagerView.vue';
import managerRead from '@/views/managers/view.vue';
import Regions from '@/views/regions/Regions.vue';
import RegionsView from '@/views/regions/RegionsView.vue';
import RegionsUpdate from '@/views/regions/RegionsUpdate.vue';
import RegionsRead from '@/views/regions/view.vue';
import CitieAdd from '@/views/cities/CitieAdd.vue';
import CitiesView from '@/views/cities/CitiesView.vue';
import CitieUpdate from '@/views/cities/CitieUpdate.vue';
import NeighborhoodAdd from '@/views/neighborhoods/NeighborhoodAdd.vue';
import NeighborhoodView from '@/views/neighborhoods/NeighborhoodView.vue';
import NeighborhoodUpdate from '@/views/neighborhoods/NeighborhoodUpdate.vue';
import NeighborhoodRead from '@/views/neighborhoods/view.vue';
import AgentAdd from '@/views/Agents/AgentAdd.vue';
import AgentView from '@/views/Agents/AgentView.vue';
import AgentUpdate from '@/views/Agents/AgentUpdate.vue';
import ManagerUpdate from '@/views/managers/ManagerUpdate.vue';
import TypeAdd from '@/views/Property_Type/TypeAdd.vue';
import TypesView from '@/views/Property_Type/TypesView.vue';
import TypeUpdate from '@/views/Property_Type/TypeUpdate.vue';
import TypeRead from '@/views/Property_Type/view.vue';
import FeaturesCreate from '@/views/Porperty_Features/FeaturesCreate.vue';
import FeaturesView from '@/views/Porperty_Features/FeaturesView.vue';
import FeaturesUpdate from '@/views/Porperty_Features/FeaturesUpdate.vue';
import FeaturesRead from '@/views/Porperty_Features/view.vue';
import ErrorLogs from '@/views/users/ErrorLogs.vue';
import ErrorView from '@/views/users/ErrorView.vue';
import PropertiesList from '@/views/properties/list.vue';
import PropertiesCreate from '@/views/properties/create.vue';
import PropertiesUpdate from '@/views/properties/update.vue'
import PropertyDocs from '@/views/property_docs/list.vue';
import PropertyDocUpdate from '@/views/property_docs/update.vue';
import PropertyDocCreate from '@/views/property_docs/create.vue';
import ManagementReqs from '@/views/management_reqs/list.vue';
import ManagementReqsUpdate from '@/views/management_reqs/update.vue';
import ManagementReqsCreate from '@/views/management_reqs/create.vue';
import Settings from '@/views/settings/list.vue';
import SettingsCreate from '@/views/settings/create.vue';
import SettingsUpdate from '@/views/settings/update.vue';
import PreRegister from '@/views/users_buffers/list.vue';
import PreRegisterUpdate from '@/views/users_buffers/update.vue';
import Reservations from '@/views/reservations/list.vue';
import ReservationsUpdate from '@/views/reservations/update.vue';
import ReservationsCreate from '@/views/reservations/create.vue';
import Payments from '@/views/payments/list.vue';
import PaymentsUpdate from '@/views/payments/update.vue';
import BookingList from '@/views/booking/list.vue';
import BookingUpdate from '@/views/booking/update.vue';
import BookingCreate from '@/views/booking/create.vue';
import QuestionsList from '@/views/questions/list.vue';
import QuestionsCreate from '@/views/questions/create.vue';
import QuestionsUpdate from '@/views/questions/update.vue';
import ProRequestList from '@/views/property_request/list.vue';
import ProRequestUpdate from '@/views/property_request/update.vue';
import ProRequestCreate from '@/views/property_request/create.vue';
import BannersList from '@/views/banners/list.vue';
import BannersCreate from '@/views/banners/create.vue';
import BannersUpdate from '@/views/banners/update.vue';
import ServicesList from '@/views/services/list.vue';
import ServicesCreate from '@/views/services/create.vue';
import ServicesUpdate from '@/views/services/update.vue';
import OrdersList from '@/views/orders/list.vue';
import OrdersUpdate from '@/views/orders/update.vue';
import ClientsList from '@/views/clients/list.vue';
import ClientsCreate from '@/views/clients/create.vue'
import ClientsUpdate from '@/views/clients/update.vue';
import ForumsList from '@/views/forums/list.vue';
import ForumsCreate from '@/views/forums/create.vue';
import ForumsUpdate from '@/views/forums/update.vue';
import ProvidersList from '@/views/providers/list.vue';
import ProvidersUpdate from '@/views/providers/update.vue';
import GroupsList from '@/views/groups/list.vue';
import GroupsCreate from '@/views/groups/create.vue';
import GroupsUpdate from '@/views/groups/update.vue';
import BanksList from '@/views/banks/list.vue';
import BanksCreate from '@/views/banks/create.vue';
import BanksUpdate from '@/views/banks/update.vue';
import NotificationsList from '@/views/notifications/list.vue';
import FinanceUpdate from '@/views/finance/update.vue';
import FinanceList from '@/views/finance/list.vue';
import FinanceCreate from '@/views/finance/create.vue';
import CouponsList from '@/views/coupons/list.vue';
import CouponsCreate from '@/views/coupons/create.vue';
import CouponsUpdate from '@/views/coupons/update.vue';
import PQuestionsList from '@/views/providers_questions/list.vue';
import PQuestionsCreate from '@/views/providers_questions/create.vue';
import PQuestionsUpdate from '@/views/providers_questions/update.vue';
import PhotoPackagesList from '@/views/photo_packages/list.vue';
import PhotoPackagesCreate from '@/views/photo_packages/create.vue';
import PhotoPackagesUpdate from '@/views/photo_packages/update.vue';
import PhotosList from '@/views/photography/list.vue';
import PhotosUpdate from '@/views/photography/update.vue';
import LawyerReqList from '@/views/lawyer_reqs/list.vue';
import LawyerReqUpdate from '@/views/lawyer_reqs/update.vue';
import LawyerReqCreate from '@/views/lawyer_reqs/create.vue';
import AgesList from '@/views/ages/list.vue';
import AgesCreate from '@/views/ages/create.vue';
import AgesUpdate from '@/views/ages/update.vue';
import ExchangeAssetsList from '@/views/exchange_assets/list.vue';
import ExchangeAssetsCreate from '@/views/exchange_assets/create.vue';
import ExchangeAssetsUpdate from '@/views/exchange_assets/update.vue';
import ExchangeBusinessesList from '@/views/exchange_businesses/list.vue';
import ExchangeBusinessesCreate from '@/views/exchange_businesses/create.vue';
import ExchangeBusinessesUpdate from '@/views/exchange_businesses/update.vue';
import ExchangeFrontsList from '@/views/exchange_fronts/list.vue';
import ExchangeFrontsCreate from '@/views/exchange_fronts/create.vue';
import ExchangeFrontsUpdate from '@/views/exchange_fronts/update.vue';
import ExchangeReasonsList from '@/views/exchange_reasons/list.vue';
import ExchangeReasonsCreate from '@/views/exchange_reasons/create.vue';
import ExchangeReasonsUpdate from '@/views/exchange_reasons/update.vue';
import ExchangeStrengthsList from '@/views/exchange_strengths/list.vue';
import ExchangeStrengthsCreate from '@/views/exchange_strengths/create.vue';
import ExchangeStrengthsUpdate from '@/views/exchange_strengths/update.vue';
import ExchangeWeaknessesList from '@/views/exchange_weaknesses/list.vue';
import ExchangeWeaknessesCreate from '@/views/exchange_weaknesses/create.vue';
import ExchangeWeaknessesUpdate from '@/views/exchange_weaknesses/update.vue';
import ExchangesList from '@/views/exchanges/list.vue';
import ExchangesCreate from '@/views/exchanges/create.vue';
import ExchangesUpdate from '@/views/exchanges/update.vue';
import HistoriesList from '@/views/histories/list.vue';
import HistoriesUpdate from '@/views/histories/update.vue';
import ComplainReasonsList from '@/views/complain_reasons/list.vue';
import ComplainReasonsCreate from '@/views/complain_reasons/create.vue';
import ComplainReasonsUpdate from '@/views/complain_reasons/update.vue';
import ComplainUpdate from '@/views/complains/update.vue';
import ComplainList from '@/views/complains/list.vue';
import AgentRead from "@/views/Agents/view.vue";
import CitiesRead from "@/views/cities/view.vue";
import PTransactionsList from '@/views/providers_transactions/list.vue';
import PTransactionsUpdate from '@/views/providers_transactions/update.vue';
import PTransactionsCreate from '@/views/providers_transactions/create.vue';
import PropertyContainerTypesList from '@/views/property_container_types/list.vue';
import PropertyContainerTypesCreate from '@/views/property_container_types/create.vue';
import PropertyContainerTypesUpdate from '@/views/property_container_types/update.vue';
import PropertyContainersList from '@/views/property_containers/list.vue';
import PropertyContainersCreate from '@/views/property_containers/create.vue';
import PropertyContainersUpdate from '@/views/property_containers/update.vue';
import ContactUsList from '@/views/contact_us/list.vue';
import ContactUsUpdate from '@/views/contact_us/update.vue';
import MNotificationsList from '@/views/marketing_notifications/list.vue';
import MNotificationsCreate from '@/views/marketing_notifications/create.vue';
import ChatCannelList from '@/views/chats/list.vue';
import Stats from '@/views/home_dashboard/form.vue';
import RestoreAccountsList from '@/views/restore_accounts/list.vue';
import RestoreAccountsUpdate from '@/views/restore_accounts/update.vue';
import OrdersCreate from '@/views/orders/create.vue';
import RegaList from '@/views/rega/list.vue';
import RegaUpdate from '@/views/rega/update.vue';
import RegaUpdateCreate from '@/views/rega_updates/create.vue';
import RegaUpdatesView from '@/views/rega_updates/update.vue';
import RegaUpdatesList from '@/views/rega_updates/list.vue';
import MNotificationsUpdate from '@/views/marketing_notifications/update.vue';
import PropertiesCreateByLicense from '@/views/properties/createByLicense.vue';
import ShareWinIndex from '@/views/share_wins/index.vue';
import LatestNewsList from '@/views/latest_news/list.vue';
import LatestNewsCreate from '@/views/latest_news/create.vue';
import LatestNewsUpdate from '@/views/latest_news/update.vue';
import OverdueRentals from '@/views/overdue_rentals/list.vue';
import GeneralMaintenanceList from '@/views/general_maintenance/list.vue';
import PaymentCreate from '@/views/payments/create.vue';
import AdLicenseReqList from '@/views/ad_license_reqs/list.vue';
import AdLicenseReqUpdate from '@/views/ad_license_reqs/update.vue';
import AdLicenseReqCreate from '@/views/ad_license_reqs/create.vue';
import RegistrationAttemptsList from '@/views/registration_attempts/list.vue';
import OrdersDelayedList from '@/views/delayed_orders/list.vue';
import MaintenancePackagesList from '@/views/maintenance_packages/list.vue';
import MaintenancePackagesCreate from '@/views/maintenance_packages/create.vue';
import MaintenancePackagesUpdate from '@/views/maintenance_packages/update.vue';
import PackagesSubscriptionsList from '@/views/packages_subscriptions/list.vue';
import PackagesSubscriptionsUpdate from '@/views/packages_subscriptions/update.vue';
import RegisterPrizesList from '@/views/register_prizes/list.vue';
import PropertiesMap from '@/views/properties/map.vue';
import PropertyMarketingMaterialsList from '@/views/property_marketing_materials/list.vue';
import PropertyBannerSizesList from '@/views/property_banner_sizes/list.vue';
import PropertyBannerSizesCreate from '@/views/property_banner_sizes/create.vue';
import PropertyBannerSizesUpdate from '@/views/property_banner_sizes/update.vue';
import AccountDetailsList from '@/views/account_details/list.vue';
import AccountDetailsUpdate from '@/views/account_details/update.vue';
import CompanyPropertyList from '@/views/company_property/list.vue';
import PropertiesArchive from '@/views/properties/archive.vue';
import CompanyDetails from '@/views/company_details/form.vue';
import PricesOffersList from '@/views/prices_offers/list.vue';
import PricesOfferForm from '@/views/prices_offers/form.vue';
import PricesOfferPrint from '@/views/prices_offers/print.vue';
import MarketingMaterialOptions from '@/views/marketing_material_options/list.vue';
import ContractsList from '@/views/contracts/list.vue';
import ContractCreate from '@/views/contracts/create.vue';
import ContractUpdate from '@/views/contracts/update.vue';
import ContractView from '@/views/contracts/view.vue';
import ContractTemplates from '@/views/contracts/templates.vue';
import ProjectsList from '@/views/projects/list.vue';
import ProjectsCreate from '@/views/projects/create.vue';
import ProjectsUpdate from '@/views/projects/update.vue';

const routes = [
  {
    path: '/',
    name: 'home',
    component: HomeView
  },
  {
    path: '/login',
    name: 'login',
    component: Login
  },
  {
    path: '/manager',
    name: 'manager',
    component: ManagerForm
  },
  {
    path: '/managerview',
    name: 'managerview',
    component: ManagerView
  },
  {
    path: '/managerupdate/:id',
    name: 'managerupdate',
    component: ManagerUpdate
  },
  {
    path: '/managerRead/:id',
    name: 'managerRead',
    component: managerRead
  },
  {
    path: '/regions',
    name: 'regions',
    component: Regions
  },
  {
    path: '/regionsview',
    name: 'regionsview',
    component: RegionsView
  },
  {
    path: '/regionsupdate/:id',
    name: 'regionsupdate',
    component: RegionsUpdate
  },
  {
    path: '/regionsRead/:id',
    name: 'RegionsRead',
    component: RegionsRead
  },
  {
    path: '/citieAdd',
    name: 'citieAdd',
    component: CitieAdd
  },
  {
    path: '/citiesview',
    name: 'citiesview',
    component: CitiesView
  },
  {
    path: '/citieupdate/:id',
    name: 'citieupdate',
    component: CitieUpdate
  },
  {
    path: '/neighborhood',
    name: 'neighborhood',
    component: NeighborhoodAdd
  },
  {
    path: '/neighborhoodview',
    name: 'neighborhoodview',
    component: NeighborhoodView
  },
  {
    path: '/neighborhoodUpdate/:id',
    name: 'neighborhoodUpdate',
    component: NeighborhoodUpdate
  },
  {
    path: '/neighborhoodRead/:id',
    name: 'NeighborhoodRead',
    component: NeighborhoodRead
  },
  {
    path: '/agent',
    name: 'agent',
    component: AgentAdd
  },
  {
    path: '/agentview',
    name: 'agentview',
    component: AgentView
  },
  {
    path: '/agentupdate/:id',
    name: 'agentupdate',
    component: AgentUpdate
  },
  {
    path: '/typecreate',
    name: 'typecreate',
    component: TypeAdd
  },
  {
    path: '/typeview',
    name: 'typeview',
    component: TypesView
  },
  {
    path: '/typeupdate/:key',
    name: 'typeupdate',
    component: TypeUpdate
  },
  {
    path: '/typeRead/:key',
    name: 'TypeRead',
    component: TypeRead
  },
  {
    path: '/featurescreate',
    name: 'featurescreate',
    component: FeaturesCreate
  },
  {
    path: '/featuresview',
    name: 'featuresview',
    component: FeaturesView
  },
  {
    path: '/featuresupdate/:key',
    name: 'featuresupdate',
    component: FeaturesUpdate
  },
  {
    path: '/featuresRead/:key',
    name: 'FeaturesRead',
    component: FeaturesRead
  },
  {
    path: '/errorlogs',
    name: 'errorlogs',
    component: ErrorLogs
  },
  {
    path: '/errorview/:key',
    name: 'errorview',
    component: ErrorView
  },
  // properties 
  {
    path: '/properties',
    name: 'PropertiesList',
    component: PropertiesList
  },
  {
    path: '/properties/create',
    name: 'PropertiesCreate',
    component: PropertiesCreate
  },
  {
    path: '/properties/createById',
    name: 'PropertiesCreateByLicense',
    component: PropertiesCreateByLicense
  },
  {
    path: '/properties/update/:id',
    name: 'PropertiesUpdate',
    component: PropertiesUpdate
  },
  // property docs
  {
    path: '/propertyDocs',
    name: 'propertyDocs',
    component: PropertyDocs,
  },
  {
    path: '/propertyDocs/create',
    name: 'propertyDocsCreate',
    component: PropertyDocCreate,
  },
  {
    path: '/propertyDocs/update/:id',
    name: 'propertyDocsUpdate',
    component: PropertyDocUpdate,
  },
  // property management requests
  {
    path: '/managementReqs',
    name: 'managementReqs',
    component: ManagementReqs,
  },
  {
    path: '/managementReqs/create',
    name: 'managementReqsCreate',
    component: ManagementReqsCreate,
  },
  {
    path: '/managementReqs/update/:id',
    name: 'managementReqsUpdate',
    component: ManagementReqsUpdate,
  },
  // settings
  {
    path: '/settings',
    name: 'settings',
    component: Settings,
  },
  {
    path: '/settings/create',
    name: 'SettingsCreate',
    component: SettingsCreate,
  },
  {
    path: '/settings/update/:id',
    name: 'SettingsUpdate',
    component: SettingsUpdate,
  },
  // users buffers
  {
    path: '/preRegister',
    name: 'PreRegister',
    component: PreRegister,
  },
  {
    path: '/preRegister/update/:id',
    name: 'PreRegisterUpdate',
    component: PreRegisterUpdate,
  },
  // reservations
  {
    path: '/reservations',
    name: 'reservations',
    component: Reservations,
  },
  {
    path: '/reservations/create',
    name: 'ReservationsCreate',
    component: ReservationsCreate,
  },
  {
    path: '/reservations/update/:id',
    name: 'ReservationsUpdate',
    component: ReservationsUpdate,
  },
  // payments
  {
    path: '/payments',
    name: 'payments',
    component: Payments,
  },
  {
    path: '/payments/create',
    name: 'PaymentCreate',
    component: PaymentCreate,
  },
  {
    path: '/payments/update/:id',
    name: 'PaymentsUpdate',
    component: PaymentsUpdate,
  },
  // booking
  {
    path: '/booking',
    name: 'booking',
    component: BookingList,
  },
  { 
    path: '/booking/create',
    name: 'BookingCreate',
    component: BookingCreate,
  },
  {
    path: '/booking/update/:id',
    name: 'BookingUpdate',
    component: BookingUpdate,
  },
  // questions 
  {
    path: '/questions',
    name: 'QuestionsList',
    component: QuestionsList
  },
  {
    path: '/questions/create',
    name: 'QuestionsCreate',
    component: QuestionsCreate
  },
  {
    path: '/questions/update/:id',
    name: 'QuestionsUpdate',
    component: QuestionsUpdate
  },
  // providers questions 
  {
    path: '/pQuestions',
    name: 'PQuestionsList',
    component: PQuestionsList
  },
  {
    path: '/pQuestions/create',
    name: 'PQuestionsCreate',
    component: PQuestionsCreate
  },
  {
    path: '/pQuestions/update/:id',
    name: 'PQuestionsUpdate',
    component: PQuestionsUpdate
  },
  // property requests 
  {
    path: '/proRequest',
    name: 'ProRequestList',
    component: ProRequestList
  },
  {
    path: '/proRequest/create',
    name: 'ProRequestCreate',
    component: ProRequestCreate
  },
  {
    path: '/proRequest/update/:id',
    name: 'ProRequestUpdate',
    component: ProRequestUpdate
  },
  // banners 
  {
    path: '/banners',
    name: 'BannersList',
    component: BannersList
  },
  {
    path: '/banners/create',
    name: 'BannersCreate',
    component: BannersCreate
  },
  {
    path: '/banners/update/:id',
    name: 'BannersUpdate',
    component: BannersUpdate
  },
  // services 
  {
    path: '/mIssues',
    name: 'ServicesList',
    component: ServicesList
  },
  {
    path: '/mIssues/create',
    name: 'ServicesCreate',
    component: ServicesCreate
  },
  {
    path: '/mIssues/update/:id',
    name: 'ServicesUpdate',
    component: ServicesUpdate
  },
  // orders 
  {
    path: '/orders',
    name: 'OrdersList',
    component: OrdersList
  },
  {
    path: '/orders/update/:id',
    name: 'OrdersUpdate',
    component: OrdersUpdate
  },
  // clients
  {
    path: '/clients',
    name: 'ClientsList',
    component: ClientsList
  },
  {
    path: '/clients/create',
    name: 'ClientsCreate',
    component: ClientsCreate
  },
  {
    path: '/clients/update/:id',
    name: 'ClientsUpdate',
    component: ClientsUpdate
  },
  // forums 
  {
    path: '/forums',
    name: 'ForumsList',
    component: ForumsList
  },
  {
    path: '/forums/create',
    name: 'ForumsCreate',
    component: ForumsCreate
  },
  {
    path: '/forums/update/:id',
    name: 'ForumsUpdate',
    component: ForumsUpdate
  },
  // providers
  {
    path: '/providers',
    name: 'ProvidersList',
    component: ProvidersList
  },
  {
    path: '/providers/update/:id',
    name: 'ProvidersUpdate',
    component: ProvidersUpdate
  },
  // groups 
  {
    path: '/groups',
    name: 'GroupsList',
    component: GroupsList
  },
  {
    path: '/groups/create',
    name: 'GroupsCreate',
    component: GroupsCreate
  },
  {
    path: '/groups/update/:id',
    name: 'GroupsUpdate',
    component: GroupsUpdate
  },
  // banks 
  {
    path: '/banks',
    name: 'banksList',
    component: BanksList
  },
  {
    path: '/banks/create',
    name: 'banksCreate',
    component: BanksCreate
  },
  {
    path: '/banks/update/:id',
    name: 'banksUpdate',
    component: BanksUpdate
  },
  // coupons 
  {
    path: '/coupons',
    name: 'couponsList',
    component: CouponsList
  },
  {
    path: '/coupons/create',
    name: 'couponsCreate',
    component: CouponsCreate
  },
  {
    path: '/coupons/update/:id',
    name: 'couponsUpdate',
    component: CouponsUpdate
  },
  // notifications
  {
    path: '/notifications',
    name: 'NotificationsList',
    component: NotificationsList
  },
  // financeRequests
  {
    path: '/financeRequests',
    name: 'FinanceList',
    component: FinanceList
  },
  {
    path: '/financeRequests/create',
    name: 'FinanceCreate',
    component: FinanceCreate
  },
  {
    path: '/financeRequests/update/:id',
    name: 'FinanceUpdate',
    component: FinanceUpdate
  },
  // photo packages 
  {
    path: '/photoPackages',
    name: 'photoPackagesList',
    component: PhotoPackagesList
  },
  {
    path: '/photoPackages/create',
    name: 'photoPackagesCreate',
    component: PhotoPackagesCreate
  },
  {
    path: '/photoPackages/update/:id',
    name: 'photoPackagesUpdate',
    component: PhotoPackagesUpdate
  },
  // photography 
  {
    path: '/photos',
    name: 'PhotosList',
    component: PhotosList
  },
  {
    path: '/photos/update/:id',
    name: 'PhotosUpdate',
    component: PhotosUpdate
  },
  // lawyer requests 
  {
    path: '/lawyerReq',
    name: 'LawyerReqList',
    component: LawyerReqList
  },
  {
    path: '/lawyerReq/create',
    name: 'LawyerReqCreate',
    component: LawyerReqCreate
  },
  {
    path: '/lawyerReq/update/:id',
    name: 'LawyerReqUpdate',
    component: LawyerReqUpdate
  },
  // ages 
  {
    path: '/ages',
    name: 'agesList',
    component: AgesList
  },
  {
    path: '/ages/create',
    name: 'agesCreate',
    component: AgesCreate
  },
  {
    path: '/ages/update/:id',
    name: 'agesUpdate',
    component: AgesUpdate
  },
  // exchange assets 
  {
    path: '/exchangeAssets',
    name: 'ExchangeAssetsList',
    component: ExchangeAssetsList
  },
  {
    path: '/exchangeAssets/create',
    name: 'ExchangeAssetsCreate',
    component: ExchangeAssetsCreate
  },
  {
    path: '/exchangeAssets/update/:id',
    name: 'ExchangeAssetsUpdate',
    component: ExchangeAssetsUpdate
  },
  // exchange businesses
  {
    path: '/exchangeBusinesses',
    name: 'exchangeBusinessesList',
    component: ExchangeBusinessesList
  },
  {
    path: '/exchangeBusinesses/create',
    name: 'exchangeBusinessesCreate',
    component: ExchangeBusinessesCreate
  },
  {
    path: '/exchangeBusinesses/update/:id',
    name: 'exchangeBusinessesUpdate',
    component: ExchangeBusinessesUpdate
  },
  // exchange fronts
  {
    path: '/exchangeFronts',
    name: 'exchangeFrontsList',
    component: ExchangeFrontsList
  },
  {
    path: '/exchangeFronts/create',
    name: 'exchangeFrontsCreate',
    component: ExchangeFrontsCreate
  },
  {
    path: '/exchangeFronts/update/:id',
    name: 'exchangeFrontsUpdate',
    component: ExchangeFrontsUpdate
  },
  // exchange reasons
  {
    path: '/exchangeReasons',
    name: 'exchangeReasonsList',
    component: ExchangeReasonsList
  },
  {
    path: '/exchangeReasons/create',
    name: 'exchangeReasonsCreate',
    component: ExchangeReasonsCreate
  },
  {
    path: '/exchangeReasons/update/:id',
    name: 'exchangeReasonsUpdate',
    component: ExchangeReasonsUpdate
  },
  // exchange strengths
  {
    path: '/exchangeStrengths',
    name: 'exchangeStrengthsList',
    component: ExchangeStrengthsList
  },
  {
    path: '/exchangeStrengths/create',
    name: 'exchangeStrengthsCreate',
    component: ExchangeStrengthsCreate
  },
  {
    path: '/exchangeStrengths/update/:id',
    name: 'exchangeStrengthsUpdate',
    component: ExchangeStrengthsUpdate
  },
  // exchange weaknesses
  {
    path: '/exchangeWeaknesses',
    name: 'exchangeWeaknessesList',
    component: ExchangeWeaknessesList
  },
  {
    path: '/exchangeWeaknesses/create',
    name: 'exchangeWeaknessesCreate',
    component: ExchangeWeaknessesCreate
  },
  {
    path: '/exchangeWeaknesses/update/:id',
    name: 'exchangeWeaknessesUpdate',
    component: ExchangeWeaknessesUpdate
  },
  // exchange
  {
    path: '/exchanges',
    name: 'exchangesList',
    component: ExchangesList
  },
  {
    path: '/exchanges/create',
    name: 'exchangesCreate',
    component: ExchangesCreate
  },
  {
    path: '/exchanges/update/:id',
    name: 'exchangesUpdate',
    component: ExchangesUpdate
  },
  // histories
  {
    path: '/histories',
    name: 'historiesList',
    component: HistoriesList
  },
  {
    path: '/histories/update/:id',
    name: 'historiesUpdate',
    component: HistoriesUpdate
  },
  // complain reasons
  {
    path: '/complainReasons',
    name: 'complainReasonsList',
    component: ComplainReasonsList
  },
  {
    path: '/complainReasons/create',
    name: 'complainReasonsCreate',
    component: ComplainReasonsCreate
  },
  {
    path: '/complainReasons/update/:id',
    name: 'complainReasonsUpdate',
    component: ComplainReasonsUpdate
  },
  // complains
  {
    path: '/complains',
    name: 'complainList',
    component: ComplainList
  },
  {
    path: '/complains/update/:id',
    name: 'complainUpdate',
    component: ComplainUpdate
  },
  {
    path: '/agent/view/:id',
    name: 'AgentRead',
    component: AgentRead
  },
  {
    path: '/cities/view/:id',
    name: 'CitiesRead',
    component: CitiesRead
  },
  // provider transactions
  {
    path: '/pTransactions',
    name: 'pTransactionsList',
    component: PTransactionsList
  },
  {
    path: '/pTransactions/update/:id',
    name: 'pTransactionsUpdate',
    component: PTransactionsUpdate
  },
  {
    path: '/pTransactions/create',
    name: 'PTransactionsCreate',
    component: PTransactionsCreate
  },
  // property container types
  {
    path: '/propertyContainerTypes',
    name: 'propertyContainerTypesList',
    component: PropertyContainerTypesList
  },
  {
    path: '/propertyContainerTypes/create',
    name: 'propertyContainerTypesCreate',
    component: PropertyContainerTypesCreate
  },
  {
    path: '/propertyContainerTypes/update/:id',
    name: 'propertyContainerTypesUpdate',
    component: PropertyContainerTypesUpdate
  },
  // property container
  {
    path: '/propertyContainers',
    name: 'propertyContainersList',
    component: PropertyContainersList
  },
  {
    path: '/propertyContainers/create',
    name: 'propertyContainersCreate',
    component: PropertyContainersCreate
  },
  {
    path: '/propertyContainers/update/:id',
    name: 'propertyContainersUpdate',
    component: PropertyContainersUpdate
  },
  // contact us
  {
    path: '/contactUs',
    name: 'contactUsList',
    component: ContactUsList
  },
  {
    path: '/contactUs/update/:id',
    name: 'contactUsUpdate',
    component: ContactUsUpdate
  },
  {
    path: '/mNotifications',
    name: 'MNotificationsList',
    component: MNotificationsList
  },
  {
    path: '/mNotifications/create',
    name: 'MNotificationsCreate',
    component: MNotificationsCreate
  },
  {
    path: '/chatContactUs',
    name: 'ChatCannelList',
    component: ChatCannelList
  },
  // dashboard
  {
    path: '/stats',
    name: 'stats',
    component: Stats
  },
  // account restoring 
  {
    path: '/restoreAccounts',
    name: 'restoreAccountsList',
    component: RestoreAccountsList
  },
  {
    path: '/restoreAccounts/update/:id',
    name: 'restoreAccountsUpdate',
    component: RestoreAccountsUpdate
  },
  // admin creates orders
  {
    path: '/orders/create',
    name: 'OrdersCreate',
    component: OrdersCreate,
  },

  // rega 
  {
    path: '/rega',
    name: 'regaList',
    component: RegaList
  },
  {
    path: '/rega/update/:id',
    name: 'regaUpdate',
    component: RegaUpdate
  },
  {
    path: '/regaUpdate/create/:id',
    name: 'regaUpdateCreate',
    component: RegaUpdateCreate
  },
  {
    path: '/regaUpdates/:id',
    name: 'RegaUpdatesList',
    component: RegaUpdatesList
  },
  {
    path: '/regaUpdates/view/:proId/:id',
    name: 'RegaUpdatesView',
    component: RegaUpdatesView
  },

  {
    path: '/mNotifications/update/:id',
    name: 'MNotificationsUpdate',
    component: MNotificationsUpdate
  },

  {
    path: '/shareWin',
    name: 'ShareWinIndex',
    component: ShareWinIndex
  },

  // latest news / bulletins
  {
    path: '/latestNews',
    name: 'LatestNewsList',
    component: LatestNewsList
  },
  {
    path: '/latestNews/create',
    name: 'LatestNewsCreate',
    component: LatestNewsCreate
  },
  {
    path: '/latestNews/update/:id',
    name: 'LatestNewsUpdate',
    component: LatestNewsUpdate
  },
  // overdue rentals
  {
    path: '/overdueRentals',
    name: 'overdueRentals',
    component: OverdueRentals,
  },
  // general maintenance orders 
  {
    path: '/general-maintenance',
    name: 'GeneralMaintenanceList',
    component: GeneralMaintenanceList
  },
  // ad license requests 
  {
    path: '/adLicenseReq',
    name: 'AdLicenseReqList',
    component: AdLicenseReqList
  },
  {
    path: '/adLicenseReq/create',
    name: 'AdLicenseReqCreate',
    component: AdLicenseReqCreate
  },
  {
    path: '/adLicenseReq/update/:id',
    name: 'AdLicenseReqUpdate',
    component: AdLicenseReqUpdate
  },
  // registration attempts
  {
    path: '/registrationAttempts',
    name: 'RegistrationAttemptsList',
    component: RegistrationAttemptsList
  },
  // delayed orders
  {
    path: '/orders/delayed',
    name: 'OrdersDelayedList',
    component: OrdersDelayedList
  },
  // maintenance packages
  {
    path: '/mPackages',
    name: 'maintenancePackagesList',
    component: MaintenancePackagesList
  },
  {
    path: '/mPackages/create',
    name: 'maintenancePackagesCreate',
    component: MaintenancePackagesCreate
  },
  {
    path: '/mPackages/update/:id',
    name: 'maintenancePackagesUpdate',
    component: MaintenancePackagesUpdate
  },
  // maintenance packages subscriptions
  {
    path: '/packagesSubscriptions',
    name: 'packagesSubscriptionsList',
    component: PackagesSubscriptionsList
  },
  {
    path: '/packagesSubscriptions/update/:id',
    name: 'packagesSubscriptionsUpdate',
    component: PackagesSubscriptionsUpdate
  },
  // register prizes
  {
    path: '/registerPrizes',
    name: 'RegisterPrizesList',
    component: RegisterPrizesList
  },
  // map
  {
    path: '/properties/map',
    name: 'PropertiesMap',
    component: PropertiesMap
  },
  // property banners markting materials
  {
    path: '/propertyMarketingMaterials',
    name: 'PropertyMarketingMaterialsList',
    component: PropertyMarketingMaterialsList
  },
  {
    path: '/marketingMaterialOptions',
    name: 'MarketingMaterialOptions',
    component: MarketingMaterialOptions
  },
  // property banners sizes
  {
    path: '/propertyBannerSizes',
    name: 'PropertyBannerSizesList',
    component: PropertyBannerSizesList
  },
  {
    path: '/propertyBannerSizes/create',
    name: 'PropertyBannerSizesCreate',
    component: PropertyBannerSizesCreate
  },
  {
    path: '/propertyBannerSizes/update/:id',
    name: 'PropertyBannerSizesUpdate',
    component: PropertyBannerSizesUpdate
  },
  // account details
  {
    path: '/accountDetails',
    name: 'AccountDetailsList',
    component: AccountDetailsList
  },
  {
    path: '/accountDetails/update/:id',
    name: 'AccountDetailsUpdate',
    component: AccountDetailsUpdate
  },
  // company property
  {
    path: '/companyProperty',
    name: 'CompanyPropertyList',
    component: CompanyPropertyList
  },
  //properties archive
  {
    path: '/properties/archive',
    name: 'PropertiesArchive',
    component: PropertiesArchive
  },
  // company details
  {
    path: '/companyDetails',
    name: 'companyDetails',
    component: CompanyDetails,
  },
  // price offers
  { 
    path: '/pricesOffers', 
    name: 'pricesOffersList', 
    component: PricesOffersList 
  },
  { path: '/pricesOffers/create', 
    name: 'pricesOffersCreate', 
    component: PricesOfferForm 
  },
  { 
    path: '/pricesOffers/update/:id', 
    name: 'pricesOffersUpdate', 
    component: PricesOfferForm 
  },
  { 
    path: '/pricesOffers/print/:id', 
    name: 'pricesOffersPrint', 
    component: PricesOfferPrint 
  },
  // contracts
  { path: '/contracts',
    name: 'contractsList',
    component: ContractsList },
  { path: '/contracts/create',
    name: 'contractsCreate',
    component: ContractCreate },
  { path: '/contracts/update/:id',
    name: 'contractsUpdate',
    component: ContractUpdate },
  { path: '/contracts/view/:id',
    name: 'contractsView',
    component: ContractView },
  { path: '/contracts/templates',
    name: 'contractTemplates',
    component: ContractTemplates },
  { path: '/contracts/employees', redirect: '/contracts' },
  // projects
  {
    path: '/projects',
    name: 'projectsList',
    component: ProjectsList
  },
  {
    path: '/projects/create',
    name: 'projectsCreate',
    component: ProjectsCreate
  },
  {
    path: '/projects/update/:id',
    name: 'projectsUpdate',
    component: ProjectsUpdate
  },
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
})

export default router